import { EventEmitter, Injectable, Output } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { EndPointApi } from '@helpers/endpointapi';
import { HttpClient } from '@angular/common/http';
import { Vessel } from 'ops/common/models/vessel';

@Injectable({ providedIn: 'root' })
export class VesselService {
    @Output() onVesselUpdated: EventEmitter<boolean> = new EventEmitter();

    private endpoint: string = EndPointApi.getURL();

    vessel: Vessel;

    constructor(private http: HttpClient) {}

    async getVessel(): Promise<Vessel> {
        return await lastValueFrom(this.http.get<any>(this.endpoint + `/api/vessel`));
    }

    async setBlobContentInDb(blobContent) {
        await lastValueFrom(this.http.post<any>(this.endpoint + `/api/vessel`, blobContent));
        this.onVesselUpdated.emit();
    }

    async loadVessel() {
        this.vessel = await lastValueFrom(this.http.get<Vessel>(this.endpoint + `/api/vessel`));
        this.onVesselUpdated.emit();
        return this.vessel;
    }
}
